import { Component, OnInit } from '@angular/core';
import { Ocorrencia } from '../models/ocorrencia';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { GlobalService } from 'src/app/services/global.service';
import { PaginatorService } from 'src/app/services/paginator.service';
import { MatDialog, PageEvent } from '@angular/material';
import { MinhasOcorrenciasService } from '../services/minhas-ocorrencias.service';
import { ClientesModalComponent } from '../modals/clientes-modal/clientes-modal.component';
import { Cliente } from '../models/cliente';
import { OcorrenciaTipo } from '../models/ocorrencia-tipo';
import { OcorrenciaTipoService } from '../services/ocorrencia-tipo.service';
import { SetorService } from '../services/setor.service';
import { Setor } from '../models/setor';
import { EtapaOcorrencia } from '../models/etapa-ocorrencia';
import { OcorrenciaService } from '../services/ocorrencia.service';

// jquery
declare const $: any;

@Component({
  selector: 'app-minhas-ocorrencias',
  templateUrl: './minhas-ocorrencias.component.html',
  styleUrls: ['./minhas-ocorrencias.component.scss']
})
export class MinhasOcorrenciasComponent implements OnInit {
  ocorrencias: Ocorrencia[] = [];
  paginacao;
  campoOrdenacao = 'id';
  ordenarDesc = false;
  itensPorPagina;
  listaDeItensPorPagina;
  idIntegrador = null;
  integrador: Cliente = new Cliente();
  suporte: boolean = false;
  administrador: boolean = false;
  ocorrenciatipo: OcorrenciaTipo[] = [];
  setores: Setor[] = [];
  etapasOcorrencia: EtapaOcorrencia[] = [];

  periodos = [
    { id: 0, name: 'Todos' },
    { id: 1, name: 'Mês Atual' },
    { id: 2, name: 'Mês Passado' },
    { id: 3, name: 'Personalizado' },
    { id: 4, name: 'Hoje' },
    { id: 5, name: 'Ontem' },
    { id: 6, name: 'Semana' },
    { id: 7, name: 'Últimos 3 Meses' },
    { id: 8, name: 'Últimos 6 Meses' },
    { id: 9, name: 'Ano Atual' }
  ];

  enumStatus = [
    { id: 0, name: 'Novo' },
    { id: 1, name: 'Em Andamento' },
    { id: 2, name: 'Concluido' },
  ];

  filtroOcorrencia = {
    idCupom: '',
    idOcorrencia: '',
    periodoSelecionado: 0,
    tipoSelecionado: undefined,
    statusSelecionados: [],
    pInicio: undefined,
    pFim: undefined,
    setorSelecionado: undefined,
    etapaOcorrencia: undefined
  };

  constructor(
    private globalService: GlobalService,
    private minhasOcorrencias: MinhasOcorrenciasService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private paginatorService: PaginatorService,
    private ocorrenciaTipoService: OcorrenciaTipoService,
    private setorService: SetorService,
    private ocorrenciaService: OcorrenciaService,

    public dialog: MatDialog,
  ) { }

  async ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;
    this.idIntegrador = (await this.globalService.consultaUsuario()).id;
    this.suporte = await this.globalService.suporte();
    this.administrador = await this.globalService.administrador();

    this.buscarSetores();
    this.buscarEtapasOcorrencia();

    if (!this.suporte && !this.administrador)
      this.buscarMinhasOcorrencias();
  }

  pesquisarCliente() {
    const dialogRef = this.dialog.open(ClientesModalComponent, {
      width: ($('body').width()).toString() + 'px',
      data: {
        gi: 1,
        esconderBotao: true
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: { cliente: Cliente }) => {
      if (result) {
        this.idIntegrador = result.cliente.id;
        this.integrador = result.cliente;

        this.buscarMinhasOcorrencias();
      }
    }
    );
  }

  buscarMinhasOcorrencias() {
    this.carregandoService.mostra('buscarMinhasOcorrencias');

    this.minhasOcorrencias.consultarComPaginacao(
      this.paginacao.paginaAtual,
      this.itensPorPagina,
      this.campoOrdenacao,
      this.ordenarDesc,
      this.idIntegrador,
      this.filtroOcorrencia.idCupom,
      this.filtroOcorrencia.periodoSelecionado,
      this.filtroOcorrencia.statusSelecionados,
      null,
      null,
      this.filtroOcorrencia.tipoSelecionado,
      this.filtroOcorrencia.pInicio,
      this.filtroOcorrencia.pFim,
      this.filtroOcorrencia.idOcorrencia,
      null,
      this.filtroOcorrencia.setorSelecionado,
      null,
      null,
      this.filtroOcorrencia.etapaOcorrencia
    ).subscribe(
      (res: { itens: Ocorrencia[], total: number }) => {
        this.ocorrencias = res.itens;
        this.paginacao.total = res.total;
        this.carregandoService.esconde('buscarMinhasOcorrencias');
      },
      (err: Error) => {
        this.carregandoService.esconde('buscarMinhasOcorrencias');
        this.notificacaoService.erro(err);
      }
    );
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarMinhasOcorrencias();
  }

  buscarOcorrenciaTipo(buscarOcorrencias?) {
    this.carregandoService.mostra('buscarOcorrenciaTipo');

    if (this.filtroOcorrencia.setorSelecionado === null || this.filtroOcorrencia.setorSelecionado === undefined) {
      this.ocorrenciaTipoService.consultarTodosOcorrenciaTipo().subscribe(
        (ocorrenciatipo: OcorrenciaTipo[]) => {
          this.ocorrenciatipo = ocorrenciatipo;
          this.carregandoService.esconde('buscarOcorrenciaTipo');

          this.filtroOcorrencia.tipoSelecionado = undefined;

          if (buscarOcorrencias) {
            this.buscarMinhasOcorrencias();
          }
        },
        (err: Error) => {
          this.carregandoService.esconde('buscarOcorrenciaTipo');
          this.notificacaoService.erro(err);
        }
      );
    } else {
      this.ocorrenciaTipoService.consultarPorIdSetor(this.filtroOcorrencia.setorSelecionado).subscribe(
        (ocorrenciatipo: OcorrenciaTipo[]) => {
          this.ocorrenciatipo = ocorrenciatipo;
          this.carregandoService.esconde('buscarOcorrenciaTipo');

          this.filtroOcorrencia.tipoSelecionado = undefined;

          if (buscarOcorrencias) {
            this.buscarMinhasOcorrencias();
          }
        },
        (err: Error) => {
          this.carregandoService.esconde('buscarOcorrenciaTipo');
          this.notificacaoService.erro(err);
        }
      );
    }
  }

  buscarSetores() {
    this.carregandoService.mostra('buscarSetores');

    this.setorService.consultarSetores().subscribe((data: any) => {
      this.setores = data;

      if (this.filtroOcorrencia.setorSelecionado !== null && this.filtroOcorrencia.setorSelecionado !== undefined &&
        !this.setores.some(p => p.id === this.filtroOcorrencia.setorSelecionado)) {
        this.filtroOcorrencia.setorSelecionado = null;
      }

      this.buscarOcorrenciaTipo();

      this.carregandoService.esconde('buscarSetores');
    }, (erro) => {
      this.carregandoService.esconde('buscarSetores');
      this.notificacaoService.erro(erro);
    });
  }

  buscarEtapasOcorrencia() {
    this.carregandoService.mostra('buscarEtapasOcorrencia');
    this.ocorrenciaService.consultarEtapas(this.filtroOcorrencia.setorSelecionado, this.filtroOcorrencia.tipoSelecionado).subscribe((data: any) => {
      this.etapasOcorrencia = data;
      this.carregandoService.esconde('buscarEtapasOcorrencia');
    }, (erro) => {
      this.carregandoService.esconde('buscarEtapasOcorrencia');
      this.notificacaoService.erro(erro);
    });
  }

  definePeriodo() {
    if (this.filtroOcorrencia.periodoSelecionado !== 3) {
      this.filtroOcorrencia.pInicio = undefined;
      this.filtroOcorrencia.pFim = undefined;

      this.buscarMinhasOcorrencias();
    }
    else {
      if (this.filtroOcorrencia.pInicio && this.filtroOcorrencia.pFim) {
        this.buscarMinhasOcorrencias();
      }
    }
  }

  retornaClasseStatus(status: number) {
    switch (status.toString()) {
      case '0':
        return 'badge-primary';
      case '1':
        return 'badge-info';
      case '2':
        return 'badge-success';
      default:
        return 'badge-info';
    }
  }

  retornaClasseEtapa(etapa: string) {
    if (!etapa) {
      return '';
    }
    return 'badge-secondary';
  }
}
